import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import 'react-responsive-modal/styles.css';
import styles from './styles.module.scss';


const AverageHoursMessage = ({value}) => {

  switch (value) {
    case 1:
      return (
        <div className={styles.message}>
          <FormattedMessage
            id='step8.form.hoursPerWeek.modal.v1.text'
            defaultMessage='According to this choice -
            you will be considered self-employed who do not meet the definition
            and will only pay the minimum for National Insurance.
            Please note - that you will not be entitled to receive pensions from National Insurance
            and you will not be insured in the work injury branch.'
          />
        </div>
      )
    case 2:
    case 3:
      return (
        <div className={styles.message}>
          <FormattedMessage
            id='step8.form.hoursPerWeek.modal.v2.text'
            defaultMessage='According to this choice -
            you will be considered self-employed who meet the definition
            and will pay advances according to the statement of your income level.
            You will be entitled to social insurance pensions as self-employed
            and you will be insured in the industry for work injuries.
            If you work in another job - you will have to pay in both places.'
          />
        </div>
      )
    default:
      return null
  }
};


AverageHoursMessage.propTypes = {
  value: PropTypes.number,
};

export default AverageHoursMessage;
